/* eslint-disable no-console */
import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop, Ref } from "@eastsideco/salvo-ts";
import Plyr from 'plyr';

/**
 * ----------------------------------------------------------------------------
 * Component: Video Player
 * - Creates featured video element for used with YouTube, Vimeo & Shopify
 * hosted videos.
 * ------------------------------------------------------------------------------
 */
@Component
export class ScrollToVideo extends ThemeComponent  {
    @Ref({required: false}) video!: HTMLVideoElement|HTMLIFrameElement|HTMLDivElement;
    @Ref pauseBtn!: HTMLElement;
    @Ref playBtn!: HTMLElement;
    @Ref({required: false}) soundBtn!: HTMLElement;
    @Ref({required: false}) muteBtn!: HTMLElement;

    private player!: Plyr;
    private userUnmuted = false;

    init() {
        if (!this.video) { return; }
        this.player = new Plyr(this.video, {
            controls: []
        });

        this.player.muted = true;
        this.userUnmuted = false;

        this.setupControls();
        this.setupScroll();
    }

    pauseVideo() {
        this.player.pause();
        this.player.muted = true;
        this.pauseBtn.classList.add('visually-hidden');
        this.playBtn.classList.remove('visually-hidden');
    }

    playVideo(autoplay = false) {
        this.player.muted = autoplay ? true : !this.userUnmuted;
        void this.player.play();
        this.pauseBtn.classList.remove('visually-hidden');
        this.playBtn.classList.add('visually-hidden');
    }


    createObserver() {
        //create intersection observer
        let observer;

        const options = {
            root: null,
            rootMargin: "0px"
        };

        const handleIntersect = (entries: IntersectionObserverEntry[]) => {
            // eslint-disable-next-line ban/ban
            entries.forEach((entry: IntersectionObserverEntry) => {
                const autoplaySet = this.video.getAttribute('data-autoplay') === 'true';
                const noscrollto = this.video.getAttribute('data-noscrollto') === 'true';

                if (noscrollto) {
                    if (autoplaySet) {
                        this.pauseVideo();
                    }else {
                        this.playVideo();
                    }
                }else {
                    if (entry.isIntersecting) {
                        this.playVideo();
                    } else {
                        this.pauseVideo();
                    }
                }
            });
        };

        // eslint-disable-next-line prefer-const
        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(this.video);
    }

    private setupControls() {

        this.$listen(this.pauseBtn, 'click', (e) => {
            e.preventDefault();
            this.pauseVideo();
        });

        this.$listen(this.playBtn, 'click', (e) => {
            e.preventDefault();
            this.playVideo();
            this.playVideo(false);
        });

        if (this.muteBtn) {
            this.$listen(this.muteBtn, 'click', (e) => {
                e.preventDefault();
                this.userUnmuted = true;
                this.player.muted = false;
                this.muteBtn.classList.add('visually-hidden');
                this.soundBtn.classList.remove('visually-hidden');

            });
        }

        if (this.soundBtn) {
            this.$listen(this.soundBtn, 'click', (e) => {
                e.preventDefault();
                this.userUnmuted = false;
                this.player.muted = true;
                this.muteBtn.classList.remove('visually-hidden');
                this.soundBtn.classList.add('visually-hidden');
            });
        }


    }

    private setupScroll() {
        this.createObserver();
    }
}
